import { useEffect, useState } from "react";
import { useApp } from "../Contex";
import { availableLocations } from "../api/api";

export default function LocationSelect() {
    const [location, setLocationState] = useState("");
    const [available, setAvailable] = useState([]);

    const { setSid, setToken } = useApp();

    useEffect(() => {
        availableLocations().then((res) => {
            if (res.ok) {
                if(res.data.length === 1){
                    const {sid} = res.data[0];
                    setSid(sid)
                }else{
                    setAvailable(res.data);
                }
            }
        });
    }, []);

    const handleSelect = () => {
        setSid(location);
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="card p-4 w-100" style={{ maxWidth: "400px" }}>
                <h3 className="mb-3 text-center">QR-ADMIN</h3>

                <div className="mb-3">
                    <label htmlFor="location" className="form-label">
                        Välj enhet
                    </label>
                    <select
                        id="location"
                        className="form-select"
                        value={location}
                        onChange={(e) => setLocationState(e.target.value)}
                    >
                        <option value="">-----</option>
                        {available.map((item) => (
                            <option value={item.sid} key={item.sid}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>

                <button
                    className="btn btn-warning w-100"
                    onClick={handleSelect}
                    disabled={!location}
                >
                    Välj
                </button>
            </div>
        </div>
    );
}
